import script from "./CustomDashboardTextModule.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomDashboardTextModule.vue?vue&type=script&setup=true&lang=js"

import "./CustomDashboardTextModule.vue?vue&type=style&index=0&id=632d69ec&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632d69ec"]])

export default __exports__